
import moment from 'moment'
import { getGdtUserToken, setGdtUserToken } from '@/api/tencent.model.js'

const BASE_URL = 'https://ad.qq.com/account-center/single/user-authorize'

export const gotoAuthorize = (redirectUri) => {
  window.location.href = `${BASE_URL}?redirect_uri=${encodeURIComponent(redirectUri)}`
}

export const getAuthInfo = async (params = {}) => {
  const { expire_time } = await getGdtUserToken(params)
  if (expire_time && expire_time > Date.now() / 1000) {
    return moment.unix(expire_time).from(moment()).replace(' ', '').slice(0, -1)
  }
  return ''
}

export const authCallbackHandler = (params) => {
  const { expire_time, user_token } = params
  if (expire_time && user_token) {
    return setGdtUserToken(params)
  }

  return Promise.reject(new Error('授权失败'))
}
